import { PostBox } from '../../components/post-box/index.troy';
import { setFileModalOpened, uploadFile } from '../../actions';
import { connectTo } from '../../utils';
import { isAuthenticatedAppLoadingSelector } from '../../selectors/loading';

export default connectTo(
  state => {
    const {
      translations: { translations },
      auth: { token, internal },
      notifications: { list: notifications, groupCounts },
      decisions: {
        'troy.feature.ui.postbox.textsearch': searchDecision,
        'troy.feature.customerupload.whatsapp': whatsappDecision
      },
      ui: {
        postBox: {
          blur: {
            fileUpload: fileUploadBlur,
            notificationsList: notificationsListBlur
          },
          hide: { fileUpload: fileUploadHidden }
        }
      },
      fileUpload: {
        isLoading: isFileLoading,
        isModalOpened: isFileModalOpened,
        isUploadSuccessful: isFileUploadSuccessful
      },
      profile: { mobilePhone, phone, email }
    } = state;

    return {
      token,
      internal,
      notifications,
      groupCounts,
      searchDecision,
      fileUploadHidden,
      isFileLoading,
      isFileModalOpened,
      isFileUploadSuccessful,
      translations,
      mobilePhone,
      phone,
      email,
      whatsappDecision,
      fileUploadBlur,
      notificationsListBlur,
      isAuthenticatedAppLoading: isAuthenticatedAppLoadingSelector(state)
    };
  },
  { uploadFile, setFileModalOpened },
  PostBox
);
